import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import Newsletter from "../components/Newsletter";
import BlogAreaAll from "../components/BlogAreaAll";
import PortfolioThree from "../components/PortfolioThree";
import HeaderTwo from "../components/HeaderTwo";
import FooterThree from "../components/FooterThree";


const Blog = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {/* Preloader */}
      {active === true && <Preloader />}

      {/* Helmet */}
      <HelmetReact title={"Blog"} />

      {/* HeaderFive */}
      <HeaderTwo />

      {/* Breadcrumb */}
      <Breadcrumb title="Blog" bg={"/assets/img/bg/blogbanner.png"}/>

      {/* BlogAreaAll */}
       <PortfolioThree />

      {/* Newsletter */}
      <Newsletter />

      {/* FooterOne */}
      <FooterThree />

    </>
  );
};

export default Blog;
